/*	Copyright (c) 1996 - 2026 NoWatt Ltd				*/
/*	  All Rights Reserved  											*/

import React from 'react';
import Layout from './Layout';
import { HeroInside } from './HeroSections';
import { InsideOverview } from './PageSections';
import Clients from './Clients';
import { ServicesInside } from './Services';
import Testimonials from './Testimonials';
import Contact from './Contact';

interface PageProps { user: string | null; }

const InsidePage = ({ user }: PageProps) => (
  <Layout user={user}>
    <HeroInside />
    <InsideOverview />
    <Clients />
    <ServicesInside />
    <Testimonials />
    <Contact />
  </Layout>
);

export default InsidePage;
